import {
  Field,
  FieldProps,
  makeStyles,
  Textarea,
  TextareaOnChangeData
} from "@fluentui/react-components";

import { isVisibleComponetBaseOnRole } from "@/commons/RoleFunction.ts";
import { FluentProvider } from "../../";
import { ChangeEvent } from "react";

const useStyles = makeStyles({
  root: {
    fontWeight: 600
  },
  disabled: {
    backgroundColor: "var(--colorSubtleBackgroundHover)",
    "& textarea": {
      color: "var(--colorNeutralForeground1)"
    }
  }
});

interface ITextareaProps {
  rcName?: string;
  theme?: string;
  name?: string;
  value?: string;
  resize?: "none" | "vertical" | "horizontal";
  rcRole?: string[];
  requireRoles?: string[];
  disabled?: boolean;
  onChangeText?: (event: ChangeEvent<HTMLTextAreaElement>, newValue?: string) => void;
  placeholder?: string;
  requireOwner?: boolean;
  isOwner?: boolean;
}

const TextareaCustom = (props: ITextareaProps & FieldProps) => {
  const styles = useStyles();

  const isCanBeVisible =
    isVisibleComponetBaseOnRole(props.rcRole, props.requireRoles) &&
    (props.requireOwner ? props.isOwner : true);

  const onChange = (ev: ChangeEvent<HTMLTextAreaElement>, data: TextareaOnChangeData) => {
    if (props.onChangeText) {
      props.onChangeText(ev, data.value);
    }
  };

  const isDisabled = props.disabled || !isCanBeVisible;

  return props.theme ? (
    <FluentProvider theme={props.theme}>
      <Field
        label={props.label}
        validationMessage={props.validationMessage}
        validationMessageIcon={props.validationMessageIcon}
        validationState={props.validationState}
        required={props.required}
        style={props.style}
        className={`${props.className} ${styles.root}`}
      >
        <Textarea
          name={props.name}
          onChange={onChange}
          value={props.value}
          disabled={isDisabled}
          placeholder={props.placeholder}
          size={props.size}
          resize={props.resize}
          className={`${isDisabled ? styles.disabled : ""}`}
        />
      </Field>
    </FluentProvider>
  ) : (
    <Field
      label={props.label}
      validationMessage={props.validationMessage}
      validationMessageIcon={props.validationMessageIcon}
      validationState={props.validationState}
      required={props.required}
      style={props.style}
      className={`${props.className} ${styles.root}`}
    >
      <Textarea
        name={props.name}
        onChange={onChange}
        value={props.value}
        disabled={isDisabled}
        placeholder={props.placeholder}
        size={props.size}
        resize={props.resize}
        className={`${isDisabled ? styles.disabled : ""}`}
      />
    </Field>
  );
};

export default TextareaCustom;
